import React from "react";
import "./style.scss";
import { Menu, Dropdown, Button, Checkbox } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { setThemes, setNewsEventLanguage } from "../../actions";
import { EVENT_THEMES, normalizeTheme } from "../../DefaultValue/eventCatalog";

export const EventPreferences = ({ translation, themeLabels, fonts }) => {
  const dispatch = useDispatch();
  const subscription = useSelector(
    (state) => state.newsEventPage.subscription
  );
  const checkedThemes = subscription.themes || [];
  const language = subscription.language;

  const label = language === "ARABIC" ? translation.arabic : translation.english;

  const isChecked = (themeKey) =>
    checkedThemes.some((theme) => normalizeTheme(theme) === themeKey);

  const onChangeCheckbox = (e) => {
    const themeKey = e.target.id;
    if (e.target.checked) {
      dispatch(setThemes([...checkedThemes, themeKey]));
    } else {
      dispatch(
        setThemes(
          checkedThemes.filter((theme) => normalizeTheme(theme) !== themeKey)
        )
      );
    }
  };

  const handleMenuClick = (e) => {
    dispatch(setNewsEventLanguage(e.key));
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="ENGLISH">{translation.english}</Menu.Item>
      <Menu.Item key="ARABIC">{translation.arabic}</Menu.Item>
    </Menu>
  );

  return (
    <div className="event-preferences-wrapper">
      <div className="event-preferences-block">
        <div className="event-pre-title-bl">
          <span className="event-pre-title" style={{ color: fonts.body }}>
            {translation.eventTypes}
          </span>
        </div>
        <div className="event-pre-check-box">
          {EVENT_THEMES.map((theme) => (
            <div className="checkbox-block-item" key={theme.key}>
              <Checkbox
                checked={isChecked(theme.key)}
                id={theme.key}
                onChange={onChangeCheckbox}
              />
              <span
                className="checkbox-block-item-span"
                style={{ color: fonts.body }}
              >
                {themeLabels[theme.key] || theme.value}
              </span>
            </div>
          ))}
        </div>
        <div className="event-pre-lang-block">
          <div className="event-pre-lang-title">
            <span
              className="event-pre-lang-title-text"
              style={{ color: fonts.body }}
            >
              {translation.language}
            </span>
          </div>
          <div className="event-pre-lang-button">
            <Dropdown overlay={menu}>
              <Button className="event-pre-lang-dropdown-button">
                {label} <DownOutlined />
              </Button>
            </Dropdown>
          </div>
        </div>
      </div>
    </div>
  );
};
